import React from "react";
import { Row } from "react-bootstrap";

const Card = ({ children }) => {
  return <Row className="bg-white rounded mb-3">{children}</Row>;
};

export default Card;
